import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

import { Checkbox } from '../../../components/ui/Checkbox';

const GeofencingTab = () => {
  const [geofencingEnabled, setGeofencingEnabled] = useState(true);
  const [allowedCountries, setAllowedCountries] = useState(['MX']);
  const [allowedStates, setAllowedStates] = useState([
    'Ciudad de México', 'Jalisco', 'Nuevo León', 'Estado de México'
  ]);
  const [restrictionMode, setRestrictionMode] = useState('country'); // 'country' or 'state'

  const mexicanStates = [
    'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche',
    'Chiapas', 'Chihuahua', 'Ciudad de México', 'Coahuila', 'Colima',
    'Durango', 'Estado de México', 'Guanajuato', 'Guerrero', 'Hidalgo',
    'Jalisco', 'Michoacán', 'Morelos', 'Nayarit', 'Nuevo León', 'Oaxaca',
    'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa',
    'Sonora', 'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas'
  ];

  const handleStateToggle = (state) => {
    setAllowedStates(prev => 
      prev?.includes(state) 
        ? prev?.filter(s => s !== state)
        : [...prev, state]
    );
  };

  const handleSelectAllStates = () => {
    setAllowedStates(mexicanStates);
  };

  const handleDeselectAllStates = () => {
    setAllowedStates([]);
  };

  return (
    <div className="space-y-6">
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <Icon name="MapPin" size={20} className="text-green-600 mt-0.5" />
          <div>
            <h4 className="font-medium text-green-900">Control Geográfico</h4>
            <p className="text-sm text-green-700 mt-1">
              Configure las restricciones geográficas para el acceso al sistema. Las ubicaciones se verifican mediante geolocalización IP y cumplimiento regulatorio mexicano.
            </p>
          </div>
        </div>
      </div>
      {/* Enable/Disable Geofencing */}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="font-semibold text-foreground">Control Geográfico</h3>
            <p className="text-sm text-muted-foreground">
              Activar o desactivar las restricciones geográficas
            </p>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-sm text-muted-foreground">
              {geofencingEnabled ? 'Activado' : 'Desactivado'}
            </span>
            <button
              onClick={() => setGeofencingEnabled(!geofencingEnabled)}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                geofencingEnabled ? 'bg-primary' : 'bg-gray-200'
              }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                  geofencingEnabled ? 'translate-x-6' : 'translate-x-1'
                }`}
              />
            </button>
          </div>
        </div>

        {!geofencingEnabled && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
            <div className="flex items-center space-x-2">
              <Icon name="AlertTriangle" size={16} className="text-yellow-600" />
              <span className="text-sm text-yellow-800">
                El control geográfico está desactivado. Los usuarios pueden acceder desde cualquier ubicación.
              </span>
            </div>
          </div>
        )}
      </div>
      {geofencingEnabled && (
        <>
          {/* Restriction Mode */}
          <div className="bg-card border border-border rounded-lg p-6">
            <h3 className="font-semibold text-foreground mb-4">Nivel de Restricción</h3>
            
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <input
                  type="radio"
                  id="country-mode"
                  name="restriction-mode"
                  checked={restrictionMode === 'country'}
                  onChange={() => setRestrictionMode('country')}
                  className="w-4 h-4 text-primary border-gray-300 focus:ring-primary"
                />
                <label htmlFor="country-mode" className="flex-1">
                  <div className="font-medium text-foreground">Solo México</div>
                  <div className="text-sm text-muted-foreground">
                    Permitir acceso únicamente desde territorio mexicano
                  </div>
                </label>
              </div>

              <div className="flex items-center space-x-3">
                <input
                  type="radio"
                  id="state-mode"
                  name="restriction-mode"
                  checked={restrictionMode === 'state'}
                  onChange={() => setRestrictionMode('state')}
                  className="w-4 h-4 text-primary border-gray-300 focus:ring-primary"
                />
                <label htmlFor="state-mode" className="flex-1">
                  <div className="font-medium text-foreground">Estados Específicos</div>
                  <div className="text-sm text-muted-foreground">
                    Restringir acceso a estados mexicanos específicos
                  </div>
                </label>
              </div>
            </div>
          </div>

          {/* State Selection */}
          {restrictionMode === 'state' && (
            <div className="bg-card border border-border rounded-lg p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-semibold text-foreground">Estados Permitidos</h3>
                <div className="flex space-x-2">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={handleSelectAllStates}
                  >
                    Seleccionar Todos
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={handleDeselectAllStates}
                  >
                    Deseleccionar Todos
                  </Button>
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                {mexicanStates?.map((state) => (
                  <Checkbox
                    key={state}
                    label={state}
                    checked={allowedStates?.includes(state)}
                    onChange={() => handleStateToggle(state)}
                    className="text-sm"
                  />
                ))}
              </div>

              <div className="mt-4 p-3 bg-muted rounded-lg">
                <div className="text-sm text-muted-foreground">
                  Estados seleccionados: <span className="font-medium text-foreground">{allowedStates?.length}</span> de {mexicanStates?.length}
                </div>
              </div>
            </div>
          )}

          {/* Compliance Information */}
          <div className="bg-card border border-border rounded-lg p-6">
            <h3 className="font-semibold text-foreground mb-4">Cumplimiento Regulatorio</h3>
            
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Icon name="Shield" size={20} className="text-green-600 mt-0.5" />
                <div>
                  <div className="font-medium text-foreground">Ley Federal de Protección de Datos</div>
                  <div className="text-sm text-muted-foreground">
                    Cumplimiento con LFPDPPP para el tratamiento de datos personales en México
                  </div>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <Icon name="FileText" size={20} className="text-blue-600 mt-0.5" />
                <div>
                  <div className="font-medium text-foreground">Regulaciones Automotrices</div>
                  <div className="text-sm text-muted-foreground">
                    Alineado con normativas de PROFECO y AMDA para información vehicular
                  </div>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <Icon name="Globe" size={20} className="text-purple-600 mt-0.5" />
                <div>
                  <div className="font-medium text-foreground">Geolocalización IP</div>
                  <div className="text-sm text-muted-foreground">
                    Verificación automática de ubicación mediante servicios de geolocalización certificados
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Current Status */}
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-card border border-border rounded-lg p-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                  <Icon name="MapPin" size={20} className="text-green-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-foreground">Ubicaciones Permitidas</h4>
                  <p className="text-sm text-muted-foreground">Acceso autorizado</p>
                </div>
              </div>
              <div className="text-2xl font-bold text-foreground">
                {restrictionMode === 'country' ? '1 País' : `${allowedStates?.length} Estados`}
              </div>
              <div className="text-sm text-muted-foreground">
                {restrictionMode === 'country' ? 'México completo' : 'Estados mexicanos seleccionados'}
              </div>
            </div>

            <div className="bg-card border border-border rounded-lg p-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                  <Icon name="Activity" size={20} className="text-blue-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-foreground">Verificaciones Hoy</h4>
                  <p className="text-sm text-muted-foreground">Controles geográficos</p>
                </div>
              </div>
              <div className="text-2xl font-bold text-foreground">247</div>
              <div className="text-sm text-muted-foreground">verificaciones exitosas</div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default GeofencingTab;